import { useState, useMemo, useCallback, useContext } from 'react'
import { useSearchParams } from 'react-router-dom'
import { nuevaContraseñaSchema, passwordRules } from './nueva-contrasena.schema'
import { ValidationError } from 'yup'
import * as yup from 'yup'
import { resetPasswordHints, updatePasswordHints } from './lib'
import { OnboardingService } from '../lib/onboarding.service'
import { StepId } from '../lib/utils'
import { useUnit } from 'effector-react'
import { stepChanged, passwordSet } from '../onboarding.model'
import { $emailVerified, $user } from '../onboarding.model'
// import { AuthContext } from '../../../common/context/AuthContext'

export function useNuevaContraseña() {
  // const { user } = useContext(AuthContext)
  // const [, setSearchParams] = useSearchParams()

  // const username = useUnit($user)
  // const email = useUnit($emailVerified)
  const emitStepChange = useUnit(stepChanged)
  const emitPasswordSet = useUnit(passwordSet)

  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [errors, setErrors] = useState({})

  const passwordHints = useMemo(() => {
    return passwordRules.map(password === '' ? resetPasswordHints : updatePasswordHints(password))
  }, [password])

  const validateField = useCallback(async (field, value, schema) => {
    try {
      await schema.validateAt(field, { [field]: value })
      setErrors((prev) => ({ ...prev, [field]: null }))
    } catch (err) {
      if (err instanceof ValidationError) setErrors((prev) => ({ ...prev, [field]: err.message }))
    }
  }, [])

  const onPasswordChange = (newPassword) => {
    setPassword(newPassword)
    validateField('password', newPassword, nuevaContraseñaSchema)
    if (confirmPassword !== '') {
      validateField(
        'confirmPassword',
        confirmPassword,
        nuevaContraseñaSchema.shape({
          confirmPassword: yup.string().oneOf([newPassword, null], 'Las contraseñas no coinciden'),
        })
      )
    }
  }

  const onConfirmPasswordChange = (newConfirmPassword) => {
    setConfirmPassword(newConfirmPassword)
    validateField(
      'confirmPassword',
      newConfirmPassword,
      nuevaContraseñaSchema.shape({
        confirmPassword: yup.string().oneOf([password, null], 'Las contraseñas no coinciden'),
      })
    )
  }

  const onSubmit = async () => {
    try {
      await nuevaContraseñaSchema.validate({ password, confirmPassword }, { abortEarly: false })
      emitPasswordSet(password)
      emitStepChange(StepId.DATOS_PERSONALES)
    } catch (err) {
      if (err instanceof ValidationError) {
        const newErrors = {}

        err.inner.forEach((error) => {
          newErrors[error.path] = error.message
        })

        setErrors(newErrors)
      }
    }
  }

  const allPasswordHintsValid = passwordHints.every((hint) => hint.variant === 'success')
  const passwordsMatch = password === confirmPassword
  const disabled = !allPasswordHintsValid || !passwordsMatch || confirmPassword === ''

  return {
    password,
    confirmPassword,
    onPasswordChange,
    onConfirmPasswordChange,
    onSubmit,
    passwordHints,
    errors,
    disabled,
  }
}
